import React, { useEffect, useRef, useState } from "react";
import "./AppointmentDetails.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faLocationDot,
  faPerson,
} from "@fortawesome/free-solid-svg-icons";
import { Button, Form } from "react-bootstrap";
import Green_btn from "../../../../common-components/common_btn/green_btn/Green_btn";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";

import "swiper/css";
import "swiper/css/free-mode";
import { useNavigate, useParams } from "react-router-dom";
import {
  cancelAppointmentAction,
  getAppointment,
  uploadAppointmentReport,
} from "../../../../../features/doctor/doctorSlice";
import {
  AppointmentStatus,
  decodeId,
  formatDateTime,
  formatTime,
} from "../../../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "date-fns";
import dayjs from "dayjs";
import Success_Modal from "../../../../common-components/common_modal/success_modal/Success_Modal";
import Delete_Modal from "../../../../common-components/common_modal/delete_modal/Delete_Modal";

const AppointmentDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [prescriptionPreview, setPrescriptionPreview] = useState(null);
  const [reportPreview, setReportPreview] = useState(null);
  const [showCancelReason, setShowCancelReason] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [loading, setLoading] = useState(false);
  const imageContainerRef = useRef(null);

  const [showError, setShowError] = useState(false);
  const [successText, setSuccessText] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);

  const singleAppointment = useSelector(
    (state) => state.doctor.singleAppointment,
  );

  console.log({ singleAppointment });

  const fetch = async (id) => {
    await dispatch(getAppointment(decodeId(id)));
  };

  useEffect(() => {
    if (id) {
      fetch(id);
    }
  }, [dispatch]);

  const handlePrescriptionChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setPrescriptionPreview(URL.createObjectURL(file));
    }
  };

  const [reports, setReports] = useState([]);
  const [reportPreviews, setReportPreviews] = useState([]);

  const handleReportChange = (e) => {
    const files = Array.from(e.target.files);

    setReports(files);

    const previews = files.map((file) => ({
      file,
      preview: file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : null,
    }));

    setReportPreviews(previews);
  };

  const uploadAppointment = async () => {
    const formData = new FormData();

    reports.forEach((file) => {
      formData.append("report", file);
      // If your backend expects an array:
      // formData.append("report[]", file);
    });

    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    try {
      const response = await dispatch(
        uploadAppointmentReport({ id: decodeId(id), data: formData }),
      );

      if (response?.meta?.requestStatus === "fulfilled") {
        setModalShow(true);
        setSuccessText(response.payload.data);
        // Clear selected files
        await fetch(id);
        setReports([]);
        setReportPreviews([]);
        setTimeout(() => {
          // navigate("/");
          setModalShow(false);
          setSuccessText("");
        }, 3000);
      } else if (response?.meta?.requestStatus === "rejected") {
        setSuccessText(response.payload.errors);
        setShowError(true);

        setTimeout(() => {
          // setShowError(false);
          setSuccessText("");
        }, 5000);
      }
    } catch (err) {
      console.log(err);
      setSuccessText(err.message);
      setShowError(true);
      setTimeout(() => {
        // setShowError(false);
        setSuccessText("");
      }, 5000);
    }
  };

  const images = [
    "https://images.unsplash.com/photo-1537368910025-700350fe46c7?w=500",
    "https://images.unsplash.com/photo-1584515933487-779824d29309?w=500",
    "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=500",
    "https://images.unsplash.com/photo-1537368910025-700350fe46c7?w=500",
    "https://images.unsplash.com/photo-1584515933487-779824d29309?w=500",
    "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=500",
    "https://images.unsplash.com/photo-1537368910025-700350fe46c7?w=500",
  ];
  const getFileIcon = (type) => {
    switch (true) {
      case type.includes("pdf"):
        return "fas fa-file-pdf text-danger";

      case type.includes("word"):
      case type.includes("document"):
        return "fas fa-file-word text-primary";

      case type.includes("excel"):
      case type.includes("spreadsheet"):
      case type.includes("sheet"):
        return "fas fa-file-excel text-success";

      case type.includes("powerpoint"):
      case type.includes("presentation"):
        return "fas fa-file-powerpoint text-warning";

      case type.includes("zip"):
      case type.includes("rar"):
      case type.includes("7z"):
        return "fas fa-file-archive text-secondary";

      case type.includes("javascript"):
      case type.includes("json"):
      case type.includes("typescript"):
      case type.includes("html"):
      case type.includes("css"):
      case type.includes("xml"):
        return "fas fa-file-code text-info";

      case type.includes("text"):
        return "fas fa-file-alt text-secondary";

      case type.includes("audio"):
        return "fas fa-file-audio text-warning";

      case type.includes("video"):
        return "fas fa-file-video text-danger";

      default:
        return "fas fa-file text-muted";
    }
  };

  const cancelAppointment = async () => {
    if (!cancelReason.trim()) {
      setSuccessText("Please enter cancellation reason.");
      setShowError(true);

      setTimeout(() => {
        // setShowError(false);
        setSuccessText("");
      }, 5000);

      return;
    }

    try {
      setLoading(true);

      const response = await dispatch(
        cancelAppointmentAction({
          id: singleAppointment.id,
          data: {
            cancel_reason: cancelReason,
          },
        }),
      );

      if (response?.meta?.requestStatus === "fulfilled") {
        setModalShow(true);
        setSuccessText(response.payload.data);

        setShowCancelReason(false);
        setCancelReason("");

        await fetch(id);

        setTimeout(() => {
          navigate("/");
          setModalShow(false);
          setSuccessText("");
        }, 5000);
      } else {
        setShowError(true);
        setSuccessText(response.payload.errors);

        setTimeout(() => {
          // setShowError(false);
          setSuccessText("");
        }, 5000);
      }
    } catch (err) {
      console.log(err);

      setShowError(true);
      setSuccessText(err.message);

      setTimeout(() => {
        // setShowError(false);
        setSuccessText("");
      }, 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="AppointmentDetails">
      <div className="container">
        <h4 className="page_title">My Appointment</h4>
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="section_right">
              <p className="booking_date">
                Booking Date : {formatDateTime(singleAppointment?.createdAt)}
              </p>
              <p className="booking_date">
                Appointment No. : {singleAppointment?.appointment_no || "-"}
              </p>
              <p className="booking_date">
                Appointment Status :{" "}
                {singleAppointment?.Appointment_Status?.name || "-"}
              </p>
              <div className="doctor_details_div">
                <div className="top_div">
                  <div className="doctor_img_div">
                    <img
                      //   src="/assets/images/about_us/commitment/commitment-img.png"
                      src={
                        process.env.REACT_APP_IMG_URL +
                        singleAppointment?.Doctor?.image
                      }
                      alt="dr_img"
                      className="dr_img"
                    />
                  </div>
                  <div className="dr_detail_div">
                    <p className="dr_name">
                      {singleAppointment?.Doctor?.Doctor_Detail?.doctor_code ||
                        "-"}
                      . {singleAppointment?.Doctor?.name || "-"}
                    </p>
                    <p className="dr_specialization">
                      {" "}
                      {singleAppointment?.Doctor?.Doctor_Detail?.Specialization
                        ?.name || "-"}{" "}
                    </p>
                  </div>
                </div>

                <div className="patient_details">
                  <p className=" common_patient_detail">
                    <span className="icon_span">
                      <FontAwesomeIcon
                        icon={faPerson}
                        className="detail_icon"
                      />
                    </span>
                    {singleAppointment?.Patient?.name || "-"}{" "}
                  </p>
                  <p className="common_patient_detail">
                    <span className="icon_span">
                      <FontAwesomeIcon icon={faClock} className="detail_icon" />
                    </span>{" "}
                    {dayjs(singleAppointment?.appointment_date).format(
                      "DD MMM YYYY",
                    )}{" "}
                    {formatTime(singleAppointment?.appointment_start)}
                  </p>
                  <p className="common_patient_detail">
                    <span className="icon_span">
                      <FontAwesomeIcon
                        icon={faLocationDot}
                        className="detail_icon"
                      />
                    </span>
                    {singleAppointment?.Doctor?.Doctor_Detail?.hospital_name ||
                      "-"}
                  </p>
                </div>
              </div>
              {singleAppointment?.prescription_pdf && (
                <div className="prescribe_div">
                  {/* <Form.Group className="mb-3">
                  <Form.Label className="upload_label">
                    Upload Prescription
                  </Form.Label>

                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={handlePrescriptionChange}
                    className="image_input"
                  />
                </Form.Group> */}

                  <div className="preview_container">
                    {/* <img src={} alt="Prescription" className="preview_image" /> */}

                    <a
                      href={`${process.env.REACT_APP_IMG_URL}${singleAppointment?.prescription_pdf}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm btn-primary ms-2"
                    >
                      View Prescription
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <div className="section_left">
              <div className="total_amount_div">
                <h5 className="total_text">Consultation Fee</h5>
                <p className="amount">Rs. {singleAppointment?.fees || "0"}</p>
              </div>

              {[
                AppointmentStatus.CONFIRMED,
                AppointmentStatus.PENDING,
                AppointmentStatus.IN_PROGRESS,
              ].includes(singleAppointment?.appointment_status_id) && (
                <div className="prescribe_div">
                  <Form.Group className="mb-3">
                    <Form.Label className="upload_label">
                      Upload Reports
                    </Form.Label>

                    <Form.Control
                      type="file"
                      accept="*/*"
                      multiple
                      onChange={handleReportChange}
                      className="image_input"
                    />
                  </Form.Group>

                  {reportPreviews.length > 0 && (
                    <div className="preview_container">
                      {reportPreviews.map(({ file, preview }, index) => (
                        <div key={index} className="file_preview">
                          {preview ? (
                            <img
                              src={preview}
                              alt={file.name}
                              className="preview_image"
                            />
                          ) : (
                            <div className="file_icon">📄</div>
                          )}

                          <p className="file_name">{file?.name}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  <Button
                    variant="primary"
                    className="mt-3"
                    onClick={uploadAppointment}
                    disabled={!reports.length}
                  >
                    Upload Reports
                  </Button>
                </div>
              )}
              <div className="preview_div">
                <h4 className="preview_title">Uploaded Reports</h4>
                {/* <div
                  className="image_preview_div"
                  ref={imageContainerRef}
                  onMouseDown={handleMouseDown}
                  onMouseLeave={handleMouseLeave}
                  onMouseUp={handleMouseUp}
                  onMouseMove={handleMouseMove}
                >
                  {images.map((image, index) => (
                    <div className="preview_card" key={index}>
                      <img
                        src={image}
                        alt={`Preview ${index + 1}`}
                        className="preview_image"
                      />
                    </div>
                  ))}
                </div> */}

                <Swiper
                  modules={[FreeMode]}
                  spaceBetween={10}
                  slidesPerView={6}
                  freeMode
                  grabCursor
                  breakpoints={{
                    0: { slidesPerView: 3 },
                    320: { slidesPerView: 3.5 },
                    450: { slidesPerView: 5 },
                    768: { slidesPerView: 4 },
                    992: { slidesPerView: 5 },
                    1200: { slidesPerView: 6 },
                  }}
                  className="image_preview_swiper"
                >
                  {singleAppointment?.Appointment_Docs?.length > 0 ? (
                    singleAppointment?.Appointment_Docs?.map((file) => {
                      const fileUrl = process.env.REACT_APP_IMG_URL + file.path;

                      return (
                        <SwiperSlide key={file.id}>
                          <div
                            className="preview_card"
                            onClick={() => window.open(fileUrl, "_blank")}
                          >
                            {file.type.startsWith("image/") ? (
                              <img
                                src={fileUrl}
                                alt={file.name}
                                className="preview_image"
                              />
                            ) : (
                              <div className="file_preview">
                                <i className={getFileIcon(file.type)}></i>
                              </div>
                            )}

                            <p className="file_name" title={file.name}>
                              {file.name}
                            </p>
                          </div>
                        </SwiperSlide>
                      );
                    })
                  ) : (
                    <p>No files Found</p>
                  )}
                </Swiper>
              </div>
            </div>
          </div>
        </div>

        {[AppointmentStatus.PENDING, AppointmentStatus.CONFIRMED].includes(
          singleAppointment?.appointment_status_id,
        ) && (
          <>
            <div className="cancel_btn_holder">
              <Green_btn
                btnText={
                  showCancelReason ? "Hide Cancellation" : "Cancel Appointment"
                }
                onClick={() => setShowCancelReason(!showCancelReason)}
              />
            </div>

            {showCancelReason && (
              <div className="cancel_reason_holder">
                <label className="cancel_reason_label">
                  Reason for Cancellation
                </label>

                <textarea
                  className="cancel_reason_input"
                  placeholder="Please mention the reason..."
                  rows={3}
                  maxLength={200}
                  value={cancelReason}
                  onChange={(e) => setCancelReason(e.target.value)}
                />

                <div className="text-end mt-1">
                  <small className="text-muted">
                    {cancelReason?.length}/200
                  </small>
                </div>

                <div className="d-flex gap-2 mt-3">
                  <button
                    className="btn btn-danger"
                    disabled={loading}
                    onClick={cancelAppointment}
                  >
                    {loading ? "Cancelling..." : "Confirm Cancellation"}
                  </button>

                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowCancelReason(false);
                      setCancelReason("");
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <Success_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText={successText}
      />

      <Delete_Modal
        show={showError}
        onHide={() => {
          setShowError(false);
        }}
        successText={successText}
      />
    </section>
  );
};

export default AppointmentDetails;
